import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.75 12.75L10 15.25L16.25 8.75",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckmark;
